// External deps
import { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useFormikContext } from 'formik';

// Internal deps

import { ubicationTypeEnum } from '../../../../../utils/dataStatus';
import AddUbicationForm from '../../../../AddUbicationForm/AddUbicationForm';
import { getUbicationLabel } from '../../../../../utils/getUbicationLabel';
import useUbicationForm from '../../../../CreateServiceRequest/UbicationForm/useUbicationForm';

const LocationForm = ({ params, setMaxWells, isTemplate, createSDS, eventos }) => {
  const { filteredBusinessUnits, optionsUbicationType, filteredOperations, disabledChangeUunn } =
    params;
  const { values, setFieldValue, errors, setFieldTouched, touched } = useFormikContext();

  const {
    event: eventOp,
    aditionalTeams,
    equipment,
    getEventIdPozo,
    getEventsIdTeam,
    handleSwitchAdditionTeams,
    fetchDataUbication,
    setUbicationState,
    setUunnState,
    setEventState,
    setTeamState,
    getUnitsBusinessId,
    getUnitsBusinessOfUser,
    cantWells,
    getOperationByInstallationId,
    fetchDataInstallation,
    optionUnits,
    setOptionUnits,
    fetchDataClassification,
    getOperationByClassificationId,
    getClassificationByUbicationId,
    getTypeOfEventsOptions,
    typeOfEventOptions,
    fetchDataActive,
    resetField,
    getActiveId,
    activeOptions,
    handleActiveOptions
  } = useUbicationForm(
    false,
    true,
    null,
    null,
    createSDS,
    values?.ubication?.ubicationType?.id === ubicationTypeEnum.locacion
  );

  const ubicationLabel = getUbicationLabel(values?.ubication?.ubicationType?.id);
  // We need to select this fields before search a ubication or instalation
  const disableUbicationSearch =
    !values.ubication?.ubicationType ||
    ((!optionUnits?.length || !values.ubication?.uunn?.id) && isTemplate);

  const { isOyM } = values;

  const objectUbicationType = {
    label: 'Tipo de ubicación',
    placeholder: 'Buscar por tipo de ubicación',
    options: optionsUbicationType,
    name: 'ubication.ubicationType',
    onChange: (val) => {
      setFieldValue(
        'isOyM',
        val?.id !== ubicationTypeEnum.locacion && val?.id !== ubicationTypeEnum.pozo
      );
      if (val?.id !== values?.ubicationType?.id && val) {
        setFieldValue('ubication.ubicationType', val);
        // Clear dependent fields
        setFieldValue('ubication.active', null);
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.uunn', null);
        setFieldValue('ubication.classification', null);
      }
    },
    value: values?.ubication.ubicationType
  };

  const objectUunn = {
    options: optionUnits,
    onChange: (val) => {
      if (val && val?.id !== values.uunn?.id) {
        setFieldValue('ubication.uunn', val);
        setFieldTouched('ubication.uunn');
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.classification', null);
        setUunnState(val);
      }
    },
    label: 'Unidad de Negocio',
    placeholder: 'Buscar por unidad de negocio',
    isDisabled: !values.ubication.ubicationType,
    errors: errors.ubication?.uunn,
    value: values.ubication.uunn,
    name: 'ubication.uunn'
  };

  const getBusiness = (val) => {
    if (val) {
      getUnitsBusinessId({ idPozoLocation: val?.id });
    } else if (!disabledChangeUunn) {
      setFieldValue('ubication.uunn', null);
      getUnitsBusinessOfUser();
    }
  };

  const objectUbication = {
    placeholder: 'Buscar por nombre',
    name: 'ubication.ubication',
    onChange: async (val) => {
      if (val?.id !== values.ubication?.ubication?.id) {
        setFieldValue('ubication.ubication', val);
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setUbicationState(val);
        if (
          values.ubication?.ubicationType?.id === ubicationTypeEnum.genericaOverhead ||
          values.ubication?.ubicationType?.id === ubicationTypeEnum.genericaProyecto
        ) {
          getClassificationByUbicationId(val?.id);
        }

        getBusiness(val);
        if (val?.id && !values?.ubication?.active) {
          // TODO: Search assets of the selected location
          getActiveId({
            tipoUbicacionId: values.ubication?.ubicationType?.id,
            ubicacionId: val.id
          });
        }
        // If it is a well, fetch the events
        if (val && values.ubication?.ubicationType?.id === ubicationTypeEnum.pozo) {
          getEventIdPozo(val);
        }
        if (val && values.ubication?.ubicationType?.id === ubicationTypeEnum.locacion) {
          getTypeOfEventsOptions(val?.id);
        }
      }
      if (!val) {
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.typeEvent', null);
        setFieldValue('ubication.installation', null);
        setFieldValue('ubication.uunn', null);
        setFieldValue('ubication.active', null);
      }
    },
    value: values.ubication.ubication,
    isDisabled: disableUbicationSearch,
    label: ubicationLabel,
    fetchData: (value) =>
      fetchDataUbication(value, values.ubication.uunn ? values.ubication.uunn.id : 0)
  };

  const objectEvent = {
    label: 'Evento',
    placeholder: 'Selecciona un evento',
    options:
      isOyM || isTemplate || !eventos.length
        ? eventOp
        : eventOp.filter((opt) => eventos.some((evt) => opt.id === evt.id)),
    name: 'ubication.event',
    isDisabled: !values.ubication.ubicationType || !values.ubication.ubication,
    onChange: async (val) => {
      if (val?.eventoPozoId !== values?.ubication?.event?.eventoPozoId) {
        setFieldValue('ubication.event', val);
        if (val) {
          getEventsIdTeam(val);
          setEventState(val);
        }
      }
    },
    value: values.ubication.event
  };

  const objectTeam = {
    label: 'Equipo',
    placeholder: 'Selecciona un equipo',
    options: equipment,
    name: 'ubication.team',
    isDisabled: !values.ubication.ubicationType || !values.ubication.event,
    onChange: async (val) => {
      if (val?.id !== values?.team?.id) {
        setFieldValue('ubication.team', val);
        setTeamState(val);
      }
    },
    value: values.ubication.team
  };

  const objectInstallation = {
    label: 'Instalación',
    name: 'ubication.installation',
    onChange: (value) => {
      if (value !== values.ubication.installation?.id) {
        setFieldValue('ubication.installation', value);
        setFieldTouched('ubication.installation');
        if (value) {
          getOperationByInstallationId(value.id);
          // TODO: Search assets of the selected location
          getActiveId({
            tipoUbicacionId: values.ubication?.ubicationType?.id,
            instalacionId: value.id
          });
        } else {
          setFieldValue('ubication.uunn', null);
          setFieldValue('ubication.ubication', null);
          setFieldValue('ubication.active', null);
        }
      }
    },
    placeholder: 'Seleccione una instalación',
    value: values.ubication.installation,
    fetchData: (value) => fetchDataInstallation(value),
    isDisabled: disableUbicationSearch
  };

  const objectEquipment = {
    label: 'Equipo',
    name: 'ubication.equipment',
    onChange: (event) => {
      setFieldValue('ubication.equipment', event.target.value);
    },
    value: values.ubication.equipment,
    errors: 'Máximo 10 caracteres'
  };

  const objectClassification = {
    label: 'Clasificación',
    name: 'ubication.classification',
    onChange: (value) => {
      if (value.id !== values.ubication.classification?.id) {
        setFieldValue('ubication.classification', value);
        setFieldTouched('ubication.classification');
        if (value) {
          getOperationByClassificationId(value.id);
          // TODO: Search assets of the selected location
          getActiveId({
            tipoUbicacionId: values.ubication?.ubicationType?.id,
            clasificacionId: value.id
          });
        } else {
          setFieldValue('ubication.ubication', null);
          setFieldValue('ubication.active', null);
        }
      }
    },
    placeholder: 'Buscar por clasificación',
    value: values.ubication.classification,
    fetchData: (value) => fetchDataClassification(value),
    isDisabled: disableUbicationSearch
  };

  const objectTypeEvent = {
    label: 'Tipo de Evento',
    placeholder: 'Selecciona tipo de evento',
    options:
      isOyM || isTemplate || !eventos.length
        ? typeOfEventOptions
        : typeOfEventOptions.filter((typeE) => eventos.some((evt) => typeE.id === evt.id)),
    name: 'ubication.typeEvent',
    isDisabled: !values.ubication?.ubication,

    onChange: (val) => {
      if (val?.id !== values?.ubication?.typeEvent?.id) {
        setFieldValue('ubication.typeEvent', val);
        setFieldTouched('ubication.typeEvent');
      }
    },
    isInvalid:
      errors?.ubication?.typeEvent && touched?.ubication?.typeEvent
        ? !!touched?.ubication?.typeEvent && !!errors?.ubication?.typeEvent
        : false,

    value: values.ubication?.typeEvent,
    errors: errors?.ubication?.typeEvent
  };
  const handleActiveChange = (val) => {
    setFieldValue('ubication.active', val);
    setFieldTouched('ubication.active');
    if (!val && val?.id !== values?.ubication.active?.id) {
      resetField(values?.ubication?.ubication, 'ubication.ubication', '');
      resetField(values?.ubication?.event, 'ubication.event', null);
      resetField(values?.ubication?.team, 'ubication.team', null);
      resetField(values?.ubication?.installation, 'ubication.installation', null);
      resetField(values?.ubication?.classification, 'ubication.classification', null);
      handleActiveOptions([]);
    } else if (!values?.ubication.uunn) {
      getUnitsBusinessId({ activeId: val?.id });
    }
  };
  const objectActive = {
    fetchData: (value) => fetchDataActive(value),
    onChange: (val) => {
      handleActiveChange(val);
      if (!val) {
        setFieldValue('ubication.uunn', null);
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.active', null);
      }
    },
    label: 'Activo',
    placeholder: 'Buscar por activo',
    isDisabled: !values.ubication?.ubicationType,
    errors: errors.ubication?.active,
    value: values.ubication?.active,
    name: 'ubication.active',
    options: activeOptions,
    clearable: true
  };

  useEffect(() => {
    setMaxWells(cantWells);
  }, [cantWells, setMaxWells]);

  useEffect(() => {
    setOptionUnits(isOyM ? filteredOperations : filteredBusinessUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOyM]);

  return (
    <div>
      <AddUbicationForm
        aditionalTeams={aditionalTeams}
        handleSwitchAdditionTeams={handleSwitchAdditionTeams}
        isMSDS
        objectActive={objectActive}
        objectClassification={objectClassification}
        objectEquipment={objectEquipment}
        objectEvent={objectEvent}
        objectInstallation={objectInstallation}
        objectTeam={objectTeam}
        objectTypeEvent={objectTypeEvent}
        objectUbication={objectUbication}
        objectUbicationType={objectUbicationType}
        objectUunn={objectUunn}
      />
    </div>
  );
};

LocationForm.propTypes = {
  params: PropTypes.shape({
    optionsUbicationType: PropTypes.arrayOf(PropTypes.shape),
    optionsBusinessOptions: PropTypes.arrayOf(PropTypes.shape),
    optionsOperations: PropTypes.arrayOf(PropTypes.shape),
    filteredOperations: PropTypes.arrayOf(PropTypes.shape),
    filteredBusinessUnits: PropTypes.arrayOf(PropTypes.shape),
    disabledChangeUunn: PropTypes.bool
  }),
  setMaxWells: PropTypes.func,
  isTemplate: PropTypes.bool.isRequired,
  createSDS: PropTypes.bool,
  eventos: PropTypes.arrayOf(PropTypes.shape)
};

LocationForm.defaultProps = {
  params: {
    optionsUbicationType: [],
    optionsBusinessOptions: [],
    optionsOperations: [],
    filteredBusinessUnits: [],
    filteredOperations: [],
    disabledChangeUunn: false
  },
  setMaxWells: () => {},
  createSDS: false,
  eventos: []
};
export default LocationForm;
